































































































































































































import { Component, mixins, Prop, Watch } from 'nuxt-property-decorator'
import { namespace } from 'vuex-class'
import { Products } from '@one/types'
import {
  Cart,
  Wishlist,
} from '@one/types/dist/orderpath/app'
import { TranslateResult } from 'vue-i18n'
import { BindingHelpers } from 'vuex-class/lib/bindings'
import LazyHydrate from 'vue-lazy-hydration'
import AddToCartMixin from '@/mixins/AddToCartMixin'
import { ProductItem, GTMListType } from '~/plugins/gtm/gtm'
import SearchResultPager = Products.Responses.SearchResultPager
import SearchFilters = Products.Responses.SearchFilters
import {
  CombinedFilterChangeEvent,
  PredefinedFilter,
  ProductsListing,
} from '~/utils/ProductsListing'
import { Throttle } from '@one/core'
import SortingOptionCode = Products.SortingOptionCode

const categories: BindingHelpers = namespace('categories')
const products = namespace('products')
const account = namespace('account')
const cart = namespace('cart')
const layout = namespace('layout')
const wishlist = namespace('wishlist')
const stocks = namespace('stocks')
const cms = namespace('cms')

const ALL_PRICE_SORT_OPTIONS: Array<string> = [
  'GROSS_PRICE_ASC',
  'NET_PRICE_ASC',
  'GROSS_PRICE_DESC',
  'NET_PRICE_DESC',
]

interface LocalBasicWishlistOrCart {
  id: string
  name: string
}
enum LayoutTypes {
  MINI_LIST = 'MINI_LIST',
  LIST = 'LIST',
  TILES = 'TILES',
}

@Component({
  components: {
    OneCategoryDescription: () =>
      import('~/components/molecules/boxes/OneCategoryDescription.vue'),
    OneToolbarList: () => import('@/components/organisms/list/OneToolbarList.vue'),
    OneSidebarHeader: () => import('~/components/molecules/sidebars/OneSidebarHeader.vue'),
    OneListingBanner: () => import('~/components/molecules/banners/OneListingBanner.vue'),
    OneSelectedFilters: () => import('~/components/organisms/filter/OneSelectedFilters.vue'),
    OneSidebar: () => import('~/components/molecules/sidebars/OneSidebar.vue'),
    OneCategoryTree: () => import('~/components/organisms/categoryTree/OneCategoryTree.vue'),
    OneFiltersContainer: () => import('~/components/molecules/filters/OneFiltersContainer.vue'),
    OnePagination: () => import('~/components/organisms/pagination/OnePagination.vue'),
    OneMobileProductsList: () => import('~/components/molecules/lists/OneMobileProductsList.vue'),
    OneProductTechnicalData: () =>
      import('~/components/organisms/product/OneProductTechnicalData.vue'),
    OneProductTitleLabels: () =>
      import('~/components/molecules/images/OneProductTitleLabels.vue'),
    OnePriceFilter: () => import('~/components/molecules/filters/OnePriceFilter.vue'),
    LazyHydrate,
  },
})
export default class OneProductsListing extends mixins(AddToCartMixin) {
  @Prop({
    required: false,
    default: null,
    type: String,
  })
  readonly categoryId!: string | null

  @Prop({
    required: false,
    type: Array,
    default: () => [],
  })
  readonly predefinedFilters!: Array<PredefinedFilter>

  @Prop({
    required: false,
    default: true,
    type: Boolean,
  })
  readonly showFilters?: boolean

  @Prop({
    required: false,
    default: true,
    type: Boolean,
  })
  readonly showCategories?: boolean

  @Prop({
    required: false,
    default: true,
    type: Boolean,
  })
  readonly showTopToolbar?: boolean

  @Prop({
    required: false,
    default: true,
    type: Boolean,
  })
  readonly showBottomToolbar?: boolean

  @Prop({
    required: false,
    default: LayoutTypes.LIST,
    type: String,
  })
  readonly defaultLayout!: LayoutTypes

  listing: ProductsListing = ProductsListing.initializeListing()
  productsLayoutName: LayoutTypes = LayoutTypes.LIST
  layoutTypesMapping: Record<LayoutTypes, Function> = {
    [LayoutTypes.MINI_LIST]: () =>
      import('@/components/organisms/list/OneProductMinilistView.vue'),
    [LayoutTypes.LIST]: () => import('@/components/organisms/list/OneProductListView.vue'),
    [LayoutTypes.TILES]: () => import('@/components/organisms/catalog/OneProductTileView.vue'),
  }

  @categories.Getter getCategory: any
  @categories.Getter getTraverseTreeForCategory: any
  @products.Getter getProductOrderUnit: any // TODO: Nie jest tutaj potrzebne! (ten komponent tego nie używa)
  @products.Getter getAttributesValue: any // TODO: Nie jest tutaj potrzebne! (ten komponent tego nie używa)
  @products.Getter getProductPrice: any // TODO: Nie jest tutaj potrzebne! (ten komponent tego nie używa)
  @products.Getter getProductImage: any
  @products.Getter getProduct: any
  @products.Action fetchProductsForSearch!: any
  @products.Action fetchFiltersForSearch!: any
  @products.Action fetchPricesForProducts!: any
  @wishlist.Getter getCurrentWishlistId: any
  @wishlist.Action addProductToWishlist: any
  @wishlist.Getter getBasicWishlists: any
  @wishlist.Getter getBasicWishlistById: any
  @wishlist.Getter getCurrentWishlist: any
  @wishlist.Getter getWishlistProduct: any
  @layout.Getter getCurrency: any
  @layout.State((state) => state.priceGross) isPriceGross!: boolean
  @layout.Getter priceType: any
  @layout.State menuFiltersShow: any
  @layout.Mutation('TOGGLE_FILTERS_MENU') toggleMenuFilters: any
  @cart.Getter getBasicCarts: any
  @cart.Getter getBasicCartById: any
  @cart.Getter getCurrentCart: any
  @stocks.Getter hasWarehouses!: boolean // TODO: Nie jest tutaj potrzebne! (tylko dlatego ze wishlisty sa tu a powinny w serwisie)
  @stocks.Action fetchStocksForProductsAndWarehouses!: any
  @stocks.State((state) => state.warehouses.allIds) allWarehousesIds!: Array<string>
  @cms.State((state) => state.configuration.registrationEnabled) isRegistrationEnabled!: boolean

  @Throttle(1500)
  async fetchProductsAndFilters() {
    const { products, filters } = await Promise.all([
      this.fetchProductsForSearch(this.listing.queryForProducts),
      this.fetchFiltersForSearch(this.listing.queryForFilters),
    ]).then(([products, filters]) => {
      return {
        products: products as SearchResultPager,
        filters: filters as SearchFilters,
      }
    })
    // @ts-ignore
    this.listing.updateListing(products, filters)
    const productsIds: Array<string> = products.items.map((p: Products.Product) => p.id)
    await this.fetchPricesForProducts(productsIds)
    this.fetchStocksForProductsAndWarehouses({
      skus: productsIds,
      warehouses: this.allWarehousesIds,
    })
  }

  @Watch('listing.queryForProducts')
  onProductsQueryChanged() {
    this.fetchProductsAndFilters()
  }

  @Watch('isPriceGross')
  async changeSortOption() {
    this.listing.setPriceType(this.priceType)
    this.listing.setPriceFilterToDefault()
  }

  @Watch('listing.selectedFilters', { immediate: true })
  switchToParentCategoryIfCategoryNotAvailable() {
    const { currentCategoryId } = this.listing
    // TODO finding parent category in such way will fail miserably because category ID property depends on client's chosen format!!!
    // https://jira.unity.pl/browse/UNITYONE-7296
    const parentCategoryId = currentCategoryId?.split('_')[0]
    const currentCategoryNoLongerAvailable =
      currentCategoryId && !this.listing.categoriesCount[currentCategoryId]
    if (
      parentCategoryId &&
      currentCategoryNoLongerAvailable &&
      this.listing.categoriesCount[parentCategoryId]
    ) {
      this.listing.selectCategory(parentCategoryId)
    }
  }

  @Watch('listing.productsForCurrentPage', { immediate: true })
  onCurrentProductsChanged(newProducts: Array<string>) {
    if (newProducts && newProducts.length && process.client) {
      this.preloadMainProductImages(newProducts)
      const mappedProducts = newProducts.map(this.getProduct).map((p: any, idx: number) => {
        return {
          item_name: p.name,
          item_id: p.id,
          item_list_name: GTMListType.STATIC_PAGE,
          item_brand: (p.brand && p.brand.name) || p.manufacturer.name,
          category: this.$routes.getCategoryPath(p.canonicalCategory) || '',
          price: p.price.priceNet,
          index: idx,
        } as ProductItem
      })
      this.$gtm?.productImpression(mappedProducts)
    }
  }

  onProductClick(product) {
    const price = this.getProductPrice(product.id)
    this.$gtm.selectItem({
      item_id: product.id,
      item_name: product.name,
      item_brand: (product.brand && product.brand.name),
      category: this.$routes.getCategoryPath(product.canonicalCategory) || '',
      price: price?.price || 0,
      discount: price?.catalogPrice - price?.price,
    } as ProductItem, GTMListType.STATIC_PAGE)
  }

  get categoriesAndFiltersHidden(): boolean {
    return !this.showCategories && !this.showFilters
  }

  /**
   * TODO: Wywalić do komponentu który tego używa (ten nie)
   * Scope: zarządzanie produktami
   */
  attributesValue(id: string): Array<Products.Attribute> {
    const attributesValue = this.getAttributesValue(id)
    return attributesValue.length ? attributesValue : null
  }

  onToggleFilters() {
    this.toggleMenuFilters(true)
  }

  preloadMainProductImages(products: Array<string>): void {
    products.map((p) => this.$utils.preloadImage(this.getProductImage(p, 'SMALL_200', 0)))
  }

  get isPriceFilterVisible(): boolean {
    const shouldHidePriceFilter: boolean =
      this.$utils.isAnonymousAndPurchaseDisabled || this.$utils.isB2B
    return !shouldHidePriceFilter && !!this.listing.priceFilter
  }

  /**
   * TODO: Zastanowić się, czy nie powinno być w ProductsListing
   * Scope: zarządzanie sortowaniem
   */
  get getSortingOptionsFilterByPriceType() {
    const shouldHidePriceSorting: boolean =
      this.$utils.isAnonymousAndPurchaseDisabled || this.$utils.isB2B
    const removePriceSortByTypePrice = [
      `${this.priceType}_PRICE_ASC`,
      `${this.priceType}_PRICE_DESC`,
    ]
    const removeOptions = !shouldHidePriceSorting
      ? removePriceSortByTypePrice
      : ALL_PRICE_SORT_OPTIONS
    return this.listing.sortingOptions.filter((el: any) => !removeOptions.includes(el.code))
  }

  get loginToBuyLabel(): string | TranslateResult {
    return this.isRegistrationEnabled
      ? (this.$t('product_page.login_or_register_to_buy') as string)
      : (this.$t('product_page.login_to_buy') as string)
  }

  /**
   * TODO: Przenieść do odpowiedniego serwisu
   * Scope: zarządzanie koszykami
   */
  get carts(): Array<Cart.Responses.BasicCartInfo | LocalBasicWishlistOrCart> {
    if (this.$auth.isAuthenticated) {
      return Object.keys(this.getBasicCarts).map((id: string) => this.getBasicCartById(id))
    }
    return (
      (this.getCurrentCart && [
        {
          id: this.getCurrentCartId,
          name: this.getCurrentCart.name,
        },
      ]) ||
      []
    )
  }

  /**
   * TODO: Przenieść do odpowiedniego serwisu
   * Scope: zarządzanie wishlistami
   */
  get wishlists(): Array<Wishlist.Responses.BasicWishlist | LocalBasicWishlistOrCart> {
    if (this.$auth.isAuthenticated) {
      return Object.keys(this.getBasicWishlists).map((id: string) =>
        this.getBasicWishlistById(id),
      )
    }
    return (
      (this.getCurrentWishlist && [
        {
          id: this.getCurrentWishlistId,
          name: this.getCurrentWishlist.name,
        },
      ]) ||
      []
    )
  }

  get menuAccount() {
    return {
      booleanValue: this.menuFiltersShow,
      uid: 'menu-filters',
    }
  }

  onCategoryClick(categoryId: string) {
    this.listing.selectCategory(categoryId)
    this.listing.setPageNumber(1)
  }

  onManufacturerClick(manufacturer: Products.Manufacturer) {
    // this.onFiltersChange({
    //   attrId: 'manufacturer',
    //   attrValueCode: manufacturer.id,
    //   value: true,
    // })
  }

  /**
   * Scope: Zarządzanie koszykami
   */
  onAddToCart(e: Cart.Requests.AddProductToCart) {
    this.$wait.start(`add-to-cart-${e.productId}`)
    this.addToCart(e.productId, e.amountOfProducts, 'static-page').finally(() =>
      this.$wait.end(`add-to-cart-${e.productId}`),
    )
  }

  /**
   * TODO: Przenieść logikę do serwisu i tu uzyć tak jak koszyków wyżej
   * Scope: zarządzanie wishlistami
   */
  onAddToWishlist(e: Wishlist.Requests.AddNumberOfProductsInWishlistOption & { wishlistId?: string }) {
    if (!this.hasWarehouses) {
      this.$notify({
        group: 'alert',
        type: 'error',
        text: this.$t('errors.no_warehouses_cart') as string,
      })
    } else {
      this.$wait.start(`add-to-wishlist-${e.productId}`)
      this.addProductToWishlist({
        wishlistId: e.wishlistId || this.getCurrentWishlistId,
        newProduct: {
          productId: e.productId,
          amountOfProducts: e.amountOfProducts,
        },
      })
        .then(() => {
          this.$notify({
            group: 'alert',
            type: 'success',
            text: this.$t('product_page.alert_added_to_wishlist') as string,
          })
          const addedProduct = this.getWishlistProduct(this.getCurrentWishlistId)(e.productId)
          this.$gtm.addToWishlist(
            {
              item_id: addedProduct.id,
              item_name: addedProduct.name,
              item_list_name: this.getCurrentWishlist.name,
              item_brand: addedProduct.brand?.name || '',
              category: this.$routes.getCategoryPath(addedProduct.canonicalCategory) || '',
              price: addedProduct.prices?.unitNet || 0,
              discount: addedProduct.prices?.catalogPriceNet - addedProduct.prices?.unitNet || 0,
              quantity: e.amountOfProducts || 0,
            },
            addedProduct.prices.unitNet * (e.amountOfProducts || 0),
          )
        })
        .finally(() => this.$wait.end(`add-to-wishlist-${e.productId}`))
    }
  }

  async onFiltersChange(event: CombinedFilterChangeEvent) {
    this.listing.updateFiltersQuery(event)
    await this.scrollTop(250)
  }

  onFilterPriceClear() {
    this.listing.clearPriceFilter()
  }

  onFiltersClear() {
    this.listing.setFilters([])
    this.listing.setPageNumber(1)
  }

  async onRowsChanged(pageSize: number) {
    await this.scrollTop(250)
    this.listing.setPageSize(pageSize)
  }

  async onSortChanged(criteria: SortingOptionCode) {
    await this.scrollTop(250)
    this.listing.setSortingCriteria(criteria)
  }

  onLayoutChange(layoutType: LayoutTypes) {
    this.productsLayoutName = layoutType
  }

  getFakeComponentName(name: LayoutTypes): string {
    const layoutMap: Record<LayoutTypes, string> = {
      [LayoutTypes.LIST]: 'one-product-list-view',
      [LayoutTypes.MINI_LIST]: 'one-product-minilist-view',
      [LayoutTypes.TILES]: 'one-product-tile-view',
    }
    return layoutMap[name].replace(/one-/g, 'one-fake-')
  }

  mounted() {
    this.productsLayoutName = this.defaultLayout ?? LayoutTypes.LIST
    this.listing.setPriceType(this.priceType)
    this.listing.selectCategory(this.categoryId)
    this.listing.setPredefinedFilters(this.predefinedFilters)
    this.listing.clearPriceFilter()
    this.fetchProductsAndFilters()
  }

  async onPrevPage() {
    await this.scrollTop(250)
    this.listing.previousPage()
  }

  async onNextPage() {
    await this.scrollTop(250)
    this.listing.nextPage()
  }

  async onPageChanged(page: number) {
    const pageIsAvailable: boolean = this.listing.setPageNumber(page)
    if (pageIsAvailable) {
      await this.scrollTop(250)
      this.$utils.hideKeyboard()
    }
  }
}
